import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../pages/base.component';
import { ToastrService } from "ngx-toastr";
import { CommonService } from "src/app/services/common.service";
import { Router } from '@angular/router';
declare var $: any;
@Component({
  selector: 'app-ict-dashboard',
  templateUrl: './ict-dashboard.component.html',
  styleUrls: ['./ict-dashboard.component.css']
})
export class IctDashboardComponent extends BaseComponent implements OnInit {

  dashboardDetails: any = ""; barChartData: any = []; barChartLabels: any[] = [];
  subCountyName: any = '';
  public barChartType: any = "bar";
  public barChartOptions: any = {
    responsive: true,
    scales: {
      xAxes: [{
        gridLines: { display: false },
        scaleLabel: { display: true, labelString: '🟦 STUDENT COUNT' }
      }],
      yAxes: [{
        gridLines: { display: true },
        ticks: { beginAtZero: true },
        scaleLabel: { display: true, labelString: '' }
      }],
    },
  };
  listGrid: any[];
  comments: any = "";
  rowData: any = "";

  constructor(
    protected CommonService: CommonService,
    protected toastr: ToastrService,
    private router: Router
  ) {
    super(CommonService, toastr);

  }

  async ngOnInit() {
    this.LoadDBDitails();
    const decryptedValue: any = await this.CommonService.decryptAesGcm(
      localStorage.getItem("RoleId"),
      this.CommonService.secretKey
    );
    this.roleId = decryptedValue;
  }


  LoadDBDitails() {
  const userData = sessionStorage.getItem("tntName");
  this.subCountyName = userData
  this.dashboardDetails = "";

  let payLoad = {
    TENANTCODE: localStorage.getItem("TenantCode"),
  };

  this.CommonService
    .postCall(`Dashboard/LoadICTChampionDashboard`, payLoad)
    .subscribe((res: any) => {
      this.dashboardDetails = res;

      /* ===============================
         APPLYING GetList() LOGIC HERE
      ================================ */

      const rawList =
        this.dashboardDetails?.Incoming_transfer_requests_Queue || [];

      const filtered = (rawList ?? []).filter((item: any) => {
        const value = item && item.IS_APPROVED;

        const createdOnTime =
          item && item.CREATED_ON
            ? new Date(item.CREATED_ON).getTime()
            : NaN;

        const isApprovedMatch =
          value === 0 || value === 3 || value === "0" || value === "3";

        const hasValidCreatedOn = Number.isFinite(createdOnTime);

        return isApprovedMatch && hasValidCreatedOn;
      });

      const sorted = filtered.slice().sort((a: any, b: any) => {
        const aTime =
          a && a.CREATED_ON ? new Date(a.CREATED_ON).getTime() : 0;

        const bTime =
          b && b.CREATED_ON ? new Date(b.CREATED_ON).getTime() : 0;

        return bTime - aTime; // Latest first
      });

      this.listGrid = sorted.slice(0, 3);

      console.log(this.listGrid);

      /* ===============================
         BAR CHART LOGIC (UNCHANGED)
      ================================ */

      const list =
        this.dashboardDetails?.Distribution_of_learners_by_Grade || [];

      this.barChartLabels = list.map(
        (x: any) => x?.COURSE_NAME ?? ""
      );

      this.barChartData = [
        {
          label: "Total",
          data: list.map((x: any) => +x?.STUDENT_COUNT || 0),
          backgroundColor: "rgba(30, 136, 229, 0.6)",
          borderColor: "#1e88e5",
          hoverBackgroundColor: "rgba(30, 136, 229, 0.8)",
          hoverBorderColor: "#1e88e5",
        },
      ];
    });
  }
  
  ApproveRej(obj: any, status: number = 1) {
    if (
      status == 1
        ? confirm("Are you sure you want to approve?")
        : confirm("Are you sure you want to Reject?")
    ) {
      if ((this.comments == "" || this.comments == null) && status == 2) {
        return this.toastr.warning("Please enter Comments");
      }
      this.activeSpinner();
      this.CommonService.postCall(`StudentTransferRequest/UpdateApprove`, {
        TRANSFERREQ_ID: obj?.TRANSFERREQ_ID,
        IS_APPROVED: status,
        COMMENTS: this.comments,
      }).subscribe(
        (res: any) => {
          this.toastr.success(
            status == 1 ? "Approved Successfully" : "Rejected Successfully"
          );
          if (status == 2) {
            $("#reject").modal("hide");
          }
          this.LoadDBDitails();
          this.deactivateSpinner();
        },
        (e) => {
          this.toastr.error(e.error.message);
          this.deactivateSpinner();
        }
      );
    }
  }

  rejectreason(obj: any) {
    this.rowData = obj;
    $("#reject").modal("show");
  }


  navigationUrl() {
    this.router.navigate([`/HOME/registration/instituteSubmission`]);
  }
  navigationUrlNew(status:any) {
    this.router.navigate([`/HOME/registration/learnerAdmission/5137`],{queryParams:{status:status}});
  }
  navigationTLUrl() {
    this.router.navigate([`/HOME/reports/learnersRegisteredSubCounty/5137`]);
  }
  navgateToSCUrl() {
    this.router.navigate([`/HOME/courseSetup/subjctCmbntnAprl`]);
  }
  navigationISUrl() {
    this.router.navigate([`/HOME/registration/schoolSubmission/5093`]);
  }

}
